import { useCases } from '@/hooks';
import { appealCases } from '../filterCases';
import { CaseList } from '../components/CaseList';

export function AppealsSection() {
  const { cases } = useCases();
  return <CaseList cases={appealCases(cases)} emptyLabel="No appeals or appealable decisions." />;
}
